<template>
    <div class="home-layout">
        <div class="block-base-info">
            <div class="block-name">
                <div class="line"></div>
                <div class="name">
                    <slot name="title"></slot>
                </div>
            </div>
        </div>
        <div class="block-base-content">
            <div class="route">
                <slot name='route'></slot>
            </div>
            <div class="filter">
                <slot name="filter"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.home-layout{
    width:1200px;
    margin-bottom:20px;
    .block-base-info{
        background: #FFF;
        border-radius: 2px;
        overflow: hidden;
        .block-name{
            height: 60px;
            padding:0px 20px;
            border-bottom:1px solid #e8e8e8;
            .line{
                width: 2px;
                height: 20px;
                line-height: 60px;
                border-left: 2px solid #FFF;
            }
            .name {
                height: 20px;
                font-size:16px;
                font-weight: bold;
                padding-left: 10px;
                line-height: 22px;
                border-left: 2px solid #105743;
            }
        }
    }
    .block-base-content{
        height: 62px;
        padding:0px 20px;
        background: #FFF;
        border-bottom: 1px solid #e8e8e8;
        overflow: hidden;
        .route{
            height:60px;
            line-height: 60px;
            float:left;
            .search {
                float:right;
                .ant-select {
                    margin-right:20px;
                }
            }
            a {
                margin:0 40px;
                display: inline-block;
                color:#333;
                font-size:14px;
                line-height: 56px;
                font-weight: normal;
            }
            .active {
                border-bottom: 2px solid #105743;
            }
        }
        .filter{
            float: right;
            line-height: 62px;
        }
    }
}
</style>